import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';
import {RootState} from 'src/store/store';

export const getEventInfo = (state: RootState): Record<string, EventDetailInfo> => state.eventInfo.data;
